import { render } from "./StoreRequisitionPurchaseOrder.vue?vue&type=template&id=1772a0c2&scoped=true"
import script from "./StoreRequisitionPurchaseOrder.vue?vue&type=script&lang=js"
export * from "./StoreRequisitionPurchaseOrder.vue?vue&type=script&lang=js"

import "./StoreRequisitionPurchaseOrder.vue?vue&type=style&index=0&id=1772a0c2&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1772a0c2"]])

export default __exports__